/* eslint-disable */
// Outreach-1.jsx
// Replaces the standalone "Outbound SMS" tab. Two sub-tabs: SMS Campaigns and Mail Campaigns.
// Drop into ~/wholesaleiq/src/Outreach-1.jsx (rename to Outreach.jsx on deploy).
//
// SMS sub-tab renders the existing OutboundSMS component unchanged.
// Mail sub-tab is a placeholder for the upcoming Lob/PostGrid integration.

import { useState } from "react";
import OutboundSMS from "./OutboundSMS";

const SUB_TABS = [
  { id: "sms",  label: "SMS CAMPAIGNS" },
  { id: "mail", label: "MAIL CAMPAIGNS" },
];

export default function Outreach(props) {
  const [tab, setTab] = useState("sms");

  return (
    <div style={{
      display: "flex", flexDirection: "column", flex: 1, overflow: "hidden",
      background: "#0A0A0B", color: "#E8E6E1", fontFamily: "'DM Sans',sans-serif",
    }}>
      {/* Sub-tab nav */}
      <div style={{
        display: "flex", alignItems: "center",
        borderBottom: "1px solid #1C1C1F",
        padding: "0 32px", height: 44, flexShrink: 0,
        background: "#0F0F11",
      }}>
        <div style={{
          fontFamily: "'DM Mono',monospace", fontSize: 10, letterSpacing: 3,
          color: "#45454A", marginRight: 24,
        }}>
          OUTREACH /
        </div>
        {SUB_TABS.map(t => (
          <button key={t.id} onClick={() => setTab(t.id)}
            style={{
              background: "none", border: "none",
              padding: "0 16px", height: 44,
              fontSize: 11, letterSpacing: 1.5, fontWeight: 700,
              fontFamily: "'DM Mono',monospace",
              cursor: "pointer",
              color: tab === t.id ? "#C9A96E" : "#45454A",
              borderBottom: tab === t.id ? "2px solid #C9A96E" : "2px solid transparent",
              marginBottom: -1,
            }}>
            {t.label}
          </button>
        ))}
      </div>

      {/* Sub-tab content */}
      <div style={{ flex: 1, overflow: "hidden", display: "flex" }}>
        {tab === "sms"  && <OutboundSMS {...props} />}
        {tab === "mail" && <MailStub subscription={props.subscription} />}
      </div>
    </div>
  );
}

// ─── Mail Campaigns stub ────────────────────────────────────────────────────
function MailStub({ subscription }) {
  const isPro = ["pro", "team"].includes(subscription?.tier)
    && ["active", "trialing"].includes(subscription?.status);

  return (
    <div style={{
      flex: 1, padding: 32, overflow: "auto",
      background: "#0A0A0B", fontFamily: "'DM Sans',sans-serif",
    }}>
      <div style={{
        maxWidth: 640, margin: "32px auto",
        background: "#111113", border: "1px solid #1C1C1F",
        borderRadius: 12, padding: 36, textAlign: "center",
      }}>
        <div style={{
          fontFamily: "'DM Mono',monospace", fontSize: 9, letterSpacing: 3,
          color: "#C9A96E", marginBottom: 10,
        }}>
          COMING NEXT
        </div>
        <h2 style={{
          margin: "0 0 14px 0", color: "#E8E6E1", fontSize: 24, fontWeight: 800,
          letterSpacing: -0.5,
        }}>
          Direct Mail Campaigns
        </h2>
        <p style={{
          color: "#6B6B70", fontSize: 14, lineHeight: 1.7,
          margin: "0 auto 24px", maxWidth: 520,
        }}>
          Drop postcards on prospects from your scraped + skip-traced list.
          Mail batches go to print weekly via Lob, with delivery tracking back
          into the campaign view. No 10DLC or TCPA exposure — fully compliant
          cold channel.
        </p>

        <div style={{
          display: "inline-block", textAlign: "left",
          background: "#0A0A0B", border: "1px solid #1C1C1F", borderRadius: 8,
          padding: "16px 22px", color: "#6B6B70", fontSize: 13, lineHeight: 1.9,
        }}>
          <div style={{
            color: "#E8E6E1", marginBottom: 8, fontWeight: 700,
            fontFamily: "'DM Mono',monospace", fontSize: 11, letterSpacing: 1.5,
          }}>
            ROADMAP
          </div>
          • Postcard template library (yellow letter, neutral, branded)<br/>
          • Mail-merge from Prospects with custom fields<br/>
          • Weekly drop scheduler with batch counts<br/>
          • Per-piece tracking via Lob webhooks<br/>
          • Inbound call-tracking on each piece for response routing
        </div>

        {!isPro && (
          <div style={{
            marginTop: 22, padding: "10px 14px",
            background: "#C9A96E0E", border: "1px solid #C9A96E33", borderRadius: 6,
            color: "#C9A96E", fontSize: 12,
            fontFamily: "'DM Mono',monospace", letterSpacing: 0.5,
          }}>
            DIRECT MAIL WILL BE A PRO/TEAM FEATURE
          </div>
        )}
      </div>
    </div>
  );
}
